import type { RootState } from '@/store';

const selectSelf = (state: RootState) => state.negociacaoSelf;

export const selectSelfStep = (state: RootState) => selectSelf(state).step;
export const selectSelfObjetivo = (state: RootState) => selectSelf(state).objetivo;
export const selectSelfPerfil = (state: RootState) => selectSelf(state).perfil;
export const selectSelfLeadId = (state: RootState) => selectSelf(state).leadId;
export const selectSelfObjetivosCatalogo = (state: RootState) =>
  selectSelf(state).objetivosCatalogo;
export const selectSelfCarregandoObjetivos = (state: RootState) =>
  selectSelf(state).carregandoObjetivos;
export const selectSelfObjetivosError = (state: RootState) => selectSelf(state).objetivosError;
export const selectSelfBuscandoContexto = (state: RootState) => selectSelf(state).buscandoContexto;
export const selectSelfBuscouContexto = (state: RootState) => selectSelf(state).buscouContexto;
export const selectSelfContextoEncontrado = (state: RootState) =>
  selectSelf(state).contextoEncontrado;
export const selectSelfTentouBuscar = (state: RootState) => selectSelf(state).tentouBuscar;
export const selectSelfContextoError = (state: RootState) => selectSelf(state).contextoError;
export const selectSelfConsultandoCnpj = (state: RootState) => selectSelf(state).consultandoCnpj;
export const selectSelfCnpjConsultado = (state: RootState) => selectSelf(state).cnpjConsultado;
export const selectSelfCnpjEncontrado = (state: RootState) => selectSelf(state).cnpjEncontrado;
export const selectSelfCnpjError = (state: RootState) => selectSelf(state).cnpjError;
export const selectSelfCamposObjetivo = (state: RootState) => selectSelf(state).camposObjetivo;
export const selectSelfCamposObjetivoDe = (state: RootState) => selectSelf(state).camposObjetivoDe;
export const selectSelfCarregandoCampos = (state: RootState) => selectSelf(state).carregandoCampos;
export const selectSelfCamposError = (state: RootState) => selectSelf(state).camposError;
export const selectSelfValoresParametros = (state: RootState) =>
  selectSelf(state).valoresParametros;
export const selectSelfCriandoAgente = (state: RootState) => selectSelf(state).criandoAgente;
export const selectSelfCriarAgenteError = (state: RootState) => selectSelf(state).criarAgenteError;
export const selectSelfPlanosCarregados = (state: RootState) => selectSelf(state).planosCarregados;
export const selectSelfPlanos = (state: RootState) => selectSelf(state).planos;
export const selectSelfCarregandoPlanos = (state: RootState) => selectSelf(state).carregandoPlanos;
export const selectSelfPlanosError = (state: RootState) => selectSelf(state).planosError;
export const selectSelfVariationId = (state: RootState) => selectSelf(state).variationId;
export const selectSelfTermosAceitos = (state: RootState) => selectSelf(state).termosAceitos;
export const selectSelfRestauracaoSessaoConcluida = (state: RootState) =>
  selectSelf(state).restauracaoSessaoConcluida;
export const selectSelfChatMensagens = (state: RootState) => selectSelf(state).chatMensagens;
export const selectSelfChatInput = (state: RootState) => selectSelf(state).chatInput;
export const selectSelfLexiDigitando = (state: RootState) => selectSelf(state).lexiDigitando;
export const selectSelfInvoiceUrl = (state: RootState) => selectSelf(state).invoiceUrl;
export const selectSelfIniciandoPagamento = (state: RootState) =>
  selectSelf(state).iniciandoPagamento;
export const selectSelfConsultandoPagamento = (state: RootState) =>
  selectSelf(state).consultandoPagamento;
export const selectSelfPagamentoError = (state: RootState) => selectSelf(state).pagamentoError;
export const selectSelfPollingPagamentoExpirado = (state: RootState) =>
  selectSelf(state).pollingPagamentoExpirado;
